export default "__VITE_ASSET__CzdOQpDE__"